import React from "react";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="block md:hidden h-full w-full bg-[#014286] flex justify-center items-center py-2">
        <div className="w-full flex items-center justify-center space-x-4 px-2">
          {/* Logo on the Left */}
          {/* <div className="w-[70px]">
            <img src="/assets/logo.png" alt="Logo" className="w-full" />
          </div> */}
          <div className="w-[100%]">
            <img
              src="/assets/srec-header-logo.png"
              alt="Logo"
              className="w-full"
            />
          </div>

          {/* College Name on the Right - Mobile*/}
          {/* <div className="text-white">
            <div className="relative">
              <h1
                className="absolute top-[-6px] m-0 p-0 left-0 text-[12px]"
                style={{ fontWeight: "900" }}
              >
                SRI
              </h1>
              <div className="w-full">
                <h1
                  className="text-[35px] mt-3 m-0 p-0 uppercase tracking-wide"
                  style={{ fontWeight: "900" }}
                >
                  RAMANUJAR
                </h1>
              </div>
              <div className="w-full">
                <h1 className="w-full block text-[19px] text-justify mt-[-11px] mb-0 font-bold uppercase tracking-wide">
                  ENGINEERING COLLEGE
                </h1>
              </div>
            </div>
            <div className="text-center">
              <p className="text-white text-[10px] text-center m-0 p-0 leading-tight">
                Since 2002, Anna University Affiliated.
              </p>
              <p className="text-white text-[10px] text-center m-0 p-0 leading-tight">
                {" "}
                Kolapakkam, Vandalur, Chennai-600127.
              </p>
              <p className="text-white text-[10px] text-center m-0 p-0 leading-tight">
                <a
                  className="no-underline text-white text-[10px] text-center m-0 p-0 leading-tight"
                  href="https://www.sriramanujar.ac.in"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.sriramanujar.ac.in
                </a>
              </p>
            </div>
          </div> */}

          {/* <div className="w-[70px]">
            <img className="w-full" alt="" src={"/assets/tnea-1.png"} />
          </div> */}
        </div>
      </div>

      <div
        className="hidden md:block !h-full !w-full"
        style={{ backgroundColor: "#014286" }}
      >
        <div className="!w-11/12 !mx-auto !flex !justify-center !items-center">
          <div className="!w-full">
            <div className="!w-full md:py-3 py-2 flex !justify-center !items-center md:!py-5 gap-5">
              {/* Logo */}
              <img
                className="!w-[35%]"
                src={"/assets/srec-header-logo.png"}
                onClick={() => navigate("/")}
                style={{ cursor: "pointer" }}
                alt="logo"
              />

              {/* Navigation */}
              <div>
                <ul className="flex gap-10 text-white font-medium m-0">
                  <li>
                    <a href="#courses">
                      Courses
                    </a>
                  </li>
                  <li>
                    <a href="#highlights">
                      Highlights
                    </a>
                  </li>
                  <li>
                    <a href="#testimonials">
                      Testimonials
                    </a>
                  </li>
                  <li>
                    <a href="#contact">
                      Contact Us
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
